import { useClientStore } from '@/app/features/ams/client/client-store';

const checkClientId = (
  _to: any,
  _from: any,
  next: (_arg?: string | undefined) => void
) => {
  const undefinedClientId = -1;
  const clientStore = useClientStore();

  if (clientStore.getSelectedClient.id === undefinedClientId) {
    next('/');
  } else {
    next();
  }
};

export { checkClientId };
